export const shouldDisplayAnnualPremium = (data) =>
  data?.premiumSummary?.isAnnual === true && data?.capabilities?.showAnnualContractValues === true;

export const getDocumentPremiumDisplay = (data, fallback) =>
  shouldDisplayAnnualPremium(data) ? data.premiumSummary : fallback;

export const getDocumentPremiumItemValue = (item, data) => {
  if (!shouldDisplayAnnualPremium(data)) return item?.value;
  return item?.contractValue ?? item?.value;
};
